export const isDev =
  (import.meta.env.MODE === 'devnet' ||
    import.meta.env.MODE === 'development' ||
    ['development', 'devnet', 'dev'].includes(import.meta.env.VITE_MODE)) &&
  ![
    'prod',
    'production',
    'production2',
    'production3',
    'production4',
    'production5',
    'production6',
    'production7',
    'production8',
  ].includes(import.meta.env.VITE_MODE);
export const isBeta = Boolean(import.meta.env.VITE_BETA_MESSAGE);
export const isHistoryFeature = import.meta.env['VITE_FEATURE_HISTORY'] === 'true';
export const isMatchingExactC2AmountFeature = import.meta.env['VITE_SWAP_EXACT_C2AMOUNT'] === 'true';
export const isSendPromisedAltFeature = import.meta.env['VITE_SEND_PROMISED_ALT'] === 'true';
